import React from "react";
import autobind from "class-autobind";
import {FormGroup} from "../group/index";
import {Input} from "../input/index";
import {Button} from "../../button/index";
import InputMask from "react-input-mask";
import DayPicker from "react-day-picker";
import moment from "moment-timezone";
import {FORMATS} from "../../../../common/utils/core/formats";

interface Props {
  locale: string;
  timezone: string;
  onSelect: (millis: number) => void;
}
interface State {
  date: Date;
  time: string;
  time_error: string;
}

export class DateTimePicker extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    autobind(this);
    this.state = {
      date: new Date(),
      time: "",
      time_error: "",
    };
  }

  onSelect() {
    const { timezone, onSelect } = this.props;
    const { date, time } = this.state;
    console.log(time);
    if (!time) {
      this.setState({ time_error: "Required" });
      return;
    }
    else if (time.length !== 5) {
      this.setState({ time_error: "Invalid, e.g. 15:00"});
      return;
    }
    // const iso_date = date.toISOString().split("T")[0];
    // const parsed = DateTime.fromFormat(`${iso_date} ${time}`, `yyyy-MM-dd hh:mm`, { zone: timezone }) . isValid;
    let parsed = moment.tz(date, timezone);
    parsed = moment.tz(`${parsed.format(FORMATS.moment.date)} ${time}`, FORMATS.moment.datetime, timezone);
    if (parsed.isValid()) {
      onSelect(parsed.valueOf());
    }
    else {
      this.setState({ time_error: "Invalid, e.g. 15:00"});
    }
  }

  render() {

    // const { onSelect } = this.props;
    const { date, time, time_error } = this.state;

    return (
      <div>

        <FormGroup contentClassName="flex-center" className="p-b-0">
          <DayPicker
            selectedDays={date}
            onDayClick={(d) => this.setState({ date: d })}
          />
        </FormGroup>

        <FormGroup title="Time (24H)" small_title={true} error={time_error}>
          <InputMask mask="99:99" value={time} onChange={(e) => this.setState({ time: e.target.value })}>
            {(inputProps: any) => (
              <Input
                type="text"
                className="no-round"
                placeholder="00:00"
                {...inputProps}
              />
            )}
          </InputMask>
        </FormGroup>

        <FormGroup>
          <Button color="primary-inverse" size="xs" full={true} type="button" onClick={this.onSelect}>
            Select
          </Button>
        </FormGroup>

      </div>
    );

  }

}
